import React from "react";
import { useHistory, Link } from "react-router-dom";
import { RightOutlined } from "@ant-design/icons";
import recentlySearchedEmptyImg from "../../../assets/images/recently-searched-empty.png";
import "./recentlySearchedCard.css";

const MOCK_SEARCHES = [
  { name: "2021 Toyota Camry SE", vin: "4T1G11AK9MU123456", active: 22, sold: 29, dom: 18 },
  { name: "2020 Honda CR-V EX", vin: "2HKRW2H58LH654321", active: 18, sold: 24, dom: 21 },
  { name: "2016 Nissan Altima", vin: "1N4AL3AP5GC987654", active: 31, sold: 12, dom: 34 },
  { name: "2018 Toyota RAV4 LE", vin: "JTMBFREV0JD246810", active: 14, sold: 21, dom: 16 }
];

function truncateVin(vin) {
  const v = vin != null ? String(vin) : "";
  if (v.length <= 12) return v;
  const start = v.substring(0, 6);
  const end = v.substring(v.length - 4);
  return `${start}…${end}`;
}

export default function RecentlySearchedCard({ searches: searchesProp }) {
  const history = useHistory();
  const searches = searchesProp !== undefined ? searchesProp : [];
  const isEmpty = !Array.isArray(searches) || searches.length === 0;
  const displayed = searches.slice(0, 3);

  function buildSearchUrl(search) {
    const params = new URLSearchParams();
    if (search.vin) params.set("vin", search.vin);
    if (search.mileage != null && search.mileage !== "") params.set("mileage", String(search.mileage));
    if (search.version) params.set("version", search.version);
    const query = params.toString();
    return query ? `/search?${query}` : "/search";
  }

  const handleSearchMarket = () => {
    history.push("/search");
  };

  return (
    <section className="rsCard" aria-label="Recently Searched">
      <header className="rsHeader">
        <div className="rsHeaderLeft">
          <h3 className="rsTitle">Recently Searched</h3>
        </div>
      </header>

      {isEmpty ? (
        <div className="rsEmpty">
          <p className="rsEmptySubhead">Your recent market searches will appear here.</p>
          <div className="rsEmptyIllustrationWrap">
            <img
              src={recentlySearchedEmptyImg}
              alt=""
              className="rsEmptyIllustration"
            />
          </div>
          <h4 className="rsEmptyTitle">Search your first vehicle</h4>
          <p className="rsEmptyDesc">
            Get instant insights on demand, pricing, and days on market in your area.
          </p>
          <button type="button" className="rsEmptyBtn" onClick={handleSearchMarket}>
            Search Market <span className="rsEmptyBtnArrow">→</span>
          </button>
        </div>
      ) : (
        <>
          <div className="rsSubhead">Your last 3 vehicle searches</div>
          <div className="rsList">
            {displayed.map((search, index) => (
              <Link
                key={search.vin || index}
                to={buildSearchUrl(search)}
                className="rsRow"
                style={{ display: "block", textDecoration: "none", color: "inherit" }}
              >
                <div className="rsContent">
                  <div className="rsVehicleName">{search.name || "—"}</div>
                  <div className="rsVin">{truncateVin(search.vin)}</div>
                  <div className="rsPills">
                    <span className="rsPill rsPill--active">Active {search.active ?? "—"}</span>
                    <span className="rsPill rsPill--sold">Sold {search.sold ?? "—"}</span>
                    <span className="rsPill rsPill--dom">DOM {search.dom != null ? search.dom : "—"}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
          <footer className="rsFooter">
            <Link className="rsSearchNewBtn" to="/search">
              <span className="rsSearchNewBtnText">Search a New Vehicle</span>
              <RightOutlined className="rsSearchNewBtnArrow" />
            </Link>
          </footer>
        </>
      )}
    </section>
  );
}
